import CopyButton from '../../components/CopyButton';

interface IRawJsonBlockProps {
  /** Names the payload, e.g. "Account JSON". */
  title: string;
  /** Null when nothing was stored, or what was stored is not a JSON object. */
  value: unknown;
}

/**
 * A stored provider payload, pretty-printed in a bounded scrolling block with
 * a copy control. `min-w-0` lets it sit in a grid or table cell without the
 * unbroken JSON lines widening its container.
 */
const RawJsonBlock = ({ title, value }: IRawJsonBlockProps) => {
  const text = value == null ? null : JSON.stringify(value, null, 2);
  return (
    <div className="flex min-w-0 flex-col gap-1">
      <div className="text-fg-tertiary flex items-center gap-1 text-[10px] uppercase tracking-wider">
        <span>{title}</span>
        {text !== null && <CopyButton value={text} label={`Copy ${title}`} successMessage={`${title} copied.`} />}
      </div>
      <pre className="bg-bg-primary text-fg-primary border-border-primary max-h-64 overflow-auto border p-2 font-mono text-[10px] leading-snug">
        {text ?? 'No payload stored'}
      </pre>
    </div>
  );
};

export default RawJsonBlock;
